import React from 'react';

import { CourseItem } from 'market/@marketCommon/components/courseItem/courseItem';

import { ICourseRecommend } from 'market/@marketCommon/interface/recommend';

import './todayCourses.scss';

interface IProps {
    data: ICourseRecommend[];
}

export const TodayCourses = ({ data }: IProps) => {
    const renderCourses = () => {
        return data.map((course) => {
            const resourceInfo = course.resource_info || {};
            const courseId = resourceInfo.encrypted_id;
            return (
                <li key={courseId}>
                    <CourseItem resourceInfo={resourceInfo} />
                </li>
            );
        });
    };

    const render = () => {
        return (
            <div className="today-courses">
                <ul className="list">{renderCourses()}</ul>
            </div>
        );
    };

    return render();
};
